<template>
    <section class="page14">
        <p class="title openSans" data-aos="fade-up">
            Já parou para pensar na enorme quantidade de informações coletadas e
            processadas pelo RH em suas ações do dia a dia?
        </p>
        <div class="spacing">
            <img
                src="~@/assets/img/page13-img1.png"
                alt=""
                data-aos="fade-up"
                data-aos-delay="300"
            />
            <div class="wrap">
                <p class="item id1" data-aos="fade-up" data-aos-delay="400">
                    Histórico profissional
                </p>
                <p class="item id2" data-aos="fade-up" data-aos-delay="500">
                    Níveis salariais
                </p>
                <p class="item id3" data-aos="fade-up" data-aos-delay="600">
                    Informações bancárias
                </p>
                <p class="item id4" data-aos="fade-up" data-aos-delay="700">
                    E-mail
                </p>
                <p class="item id5" data-aos="fade-up" data-aos-delay="800">
                    Registros médicos
                </p>
                <p class="item id6" data-aos="fade-up" data-aos-delay="900">
                    Informações residenciais
                </p>
                <p class="item id7" data-aos="fade-up" data-aos-delay="1000">
                    Documentos de identificação
                </p>
            </div>
        </div>
        <p data-aos="fade" data-aos-delay="1100">
            Para lidar com esse volume de dados de forma segura e legal, coloque
            em prática as 6 etapas do plano estratégico para atendimento à LGPD. Acompanhe a
            seguir.
        </p>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page14 {
    position: relative;
    background-image: url("~@/assets/img/page13-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 728px;
    padding-top: 40px;
    padding-bottom: 40px;
    color: #fff;
    p {
        max-width: 556px;
        margin: 0 auto;
        font-size: 1.05rem;
    }
    .title {
        max-width: 844px;
        font-size: 1.5rem;
    }
    .spacing {
        position: relative;
        padding: 40px 0;
        max-width: 900px;
        width: 100%;
        margin: 0 auto;
        img {
            width: calc(100% - 56px);
        }
    }
    .item {
        background-image: url("~@/assets/img/page13-bgitem.png");
        background-repeat: no-repeat;
        background-position-x: right;
        background-position-y: bottom;
        width: 160px;
        padding: 18px;
        margin: 10px auto;
        box-shadow: 0px 0px 16px 3px rgba(0, 0, 0, 0.1);
        position: absolute;
    }
    .id1 {
        top: 12%;
        left: 24%;
    }
    .id2 {
        top: 11%;
        right: 1%;
    }
    .id3 {
        top: 48%;
        left: 0%;
    }
    .id4 {
        bottom: 19%;
        left: 6%;
    }
    .id5 {
        bottom: 10%;
        left: 36%;
    }
    .id6 {
        bottom: 8%;
        right: 11%;
    }
    .id7 {
        bottom: 25%;
        right: 0%;
    }
    @media (max-width: 800px) {
        .wrap {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
        }
        .item {
            position: relative;
            top: 0;
            left: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 5px 5px;
            padding: 5px;
            width: 40%;
            min-height: 40px;
        }
    }
    @media (max-width: 1336px) {
        padding-left: 20px;
        padding-right: 20px;
    }
}
</style> 